// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1BWuu","label":"Radio_label__1bcxR","checkMark":"Radio_checkMark__11Qyr","disabled":"Radio_disabled__3Z0vj"};